import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import PopoverContent, { Sections } from 'components/PopoverContent'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import BodyCellContainer from 'scenes/Reports/components/Table/BodyCellContainer'
import { reportCurrency, reportPercentage } from 'scenes/Reports/helpers'
import { currencyFormatter, numberFormatter } from 'utilities/formatters'

const t = buildTranslate('points.effective_discount_rate.table')
const popoversT = buildTranslate(
  'points.effective_discount_rate.table.popovers'
)

type Props = {
  isErrored: boolean
  isLoading: boolean
  totalRedemptionsCount: number
  totalRedemptionCost: number
  dateLabel: string | null
  currentCostAmount: string
}

const SummaryRow = ({
  isErrored,
  isLoading,
  totalRedemptionsCount,
  totalRedemptionCost,
  dateLabel,
  currentCostAmount,
}: Props) => {
  const [css] = useStyletron()
  const borderClass = css({
    borderTopWidth: '2px',
    borderTopStyle: 'solid',
    borderTopColor: palette.grey30,
  })

  const totalRedemptionsCountLabel = numberFormatter(totalRedemptionsCount)
  const totalCost = reportCurrency(totalRedemptionCost, true)
  const popoverTotalCost = currencyFormatter(totalRedemptionCost, false)

  const cell = (
    value: React.ReactNode,
    {
      alignRight = true,
      sections,
    }: { alignRight?: boolean; sections?: Sections } = {}
  ) => (
    <BodyCellContainer
      isErrored={isErrored}
      isLoading={isLoading}
      className={`${borderClass} ${alignRight ? 'text-right' : ''}`}
    >
      <Text.BodyText4 tag="div" color="grey90" bold>
        <span className="mr-xs">{value}</span>
        {sections && <PopoverContent sections={sections} />}
      </Text.BodyText4>
    </BodyCellContainer>
  )

  return (
    <tr>
      {cell(t('summary_row.label'), { alignRight: false })}
      {cell(null)}
      {cell(null)}
      {cell(null)}
      {cell(totalRedemptionsCountLabel, {
        sections: [
          { content: popoversT('total_rewards_redeemed')[0] },
          {
            title: popoversT('what_this_means'),
            content: popoversT('total_rewards_redeemed', {
              dateLabel,
              totalRedemptionsCount: totalRedemptionsCountLabel,
            })[1],
          },
        ],
      })}
      {cell(reportPercentage(totalRedemptionsCount ? 1 : null))}
      {cell(totalCost, {
        sections: [
          { content: popoversT('summary')[0] },
          {
            title: popoversT('what_this_means'),
            content: popoversT('summary', { dateLabel, currentCostAmount })[1],
          },
          {
            content: popoversT('summary', {
              dateLabel,
              totalCost: popoverTotalCost,
            })[2],
          },
        ],
      })}
    </tr>
  )
}

export default SummaryRow
